<template>
    <header class="sticky top-0 z-50" :class="show && !isMobileBreakpoint ? 'show-toast' : ''">
        <AnnouncementBanner v-if="showAnnouncementBanner"/>
        <NavBar />
    </header>
</template>
 
<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'
import AnnouncementBanner from '~/components/ui/atom/announcementBanner.vue'
import NavBar from '~/components/ui/organism/navBar.vue'
import { useAddToCartToastStore } from '~/stores/addToCartToastStore'
const toastStore = useAddToCartToastStore()
const { show } = storeToRefs(toastStore)

import { useBreakpoints, breakpointsTailwind } from '@vueuse/core';


 
const showAnnouncementBanner = ref(true);
const breakPoints = useBreakpoints(breakpointsTailwind);
const isMobileBreakpoint = breakPoints.smaller('md');


defineExpose({
    showAnnouncementBanner
});

 
</script>
 
<style>
.show-toast {
    z-index: 99999 !important;
}
</style>
 
